import React, { useState } from "react";
import Collapse from "../../../components/Collapse";
import { formatBook } from "../../../utils/formatOdds";

/** Reference v-kval: 1000+ -> K (1 decimal, trailing zeros dropped) */
function formatSize(value) {
  const n = Number(value) || 0;
  return n >= 1e3 ? `${parseFloat((n / 1e3).toFixed(1))}K` : String(parseFloat(n));
}

/** Reference v-kvalpoint: 1000+ -> K (2 decimals, trailing zeros dropped) */
function formatLimit(value) {
  const n = Number(value) || 0;
  return n >= 1e3 ? `${parseFloat((n / 1e3).toFixed(2))}K` : String(parseFloat(n));
}

function getExposure(exposures, nat) {
  if (!nat) return 0;
  const v = exposures[nat] ?? exposures[nat.toLowerCase()] ?? exposures[nat.trim()] ?? 0;
  return Number(v) || 0;
}

/**
 * Ball by Ball market in the reference Market6 markup (casino/ballbyball):
 * .market-6 > .bet-table > header {title} + body #market{index} (Back titles row, then one col-6 col-md-4 per market).
 * Admin places no bets: a click on an open odds box only calls onBetClick (refresh book / bets).
 */
export default function BallByBallMarket({ data = [], title, index, exposures = {}, onBetClick }) {
  // The header opens / shuts the market with Bootstrap's slide (its data-toggle is BS4-only).
  const [open, setOpen] = useState(true);
  return (
    <div className="market-6">
      <div className="bet-table">
        <div aria-expanded={open ? "true" : "false"} className={`bet-table-header${open ? "" : " collapsed"}`} onClick={() => setOpen((v) => !v)}>
          <div className="nation-name">
            <span title={title}>{title}</span>
          </div>
        </div>{" "}
        <Collapse open={open} id={`market${index}`} className="bet-table-body container-fluid container-fluid-5">
          <div className="row row5 d-none-mobile">
            {[0, 1, 2].map((i) => (
              <React.Fragment key={i}>
                {i > 0 && " "}
                <div className="col-6 col-md-4">
                  <div className="fancy-tripple">
                    <div className="bet-table-row">
                      <div className="nation-name" />{" "}
                      <div className="back bl-title back-title">Back</div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>{" "}
          <div className="row row5">
            {data.map((s, i) => {
              const exp = getExposure(exposures, s?.nat);
              const noVal = Number(s?.b) === 0 || s?.b == null;
              const suspended = s?.gstatus !== "OPEN";
              const cls = `bl-box back${noVal ? " no-val" : ""}${suspended ? " suspended" : ""}`;
              return (
                <div key={`web${i}`} className="col-6 col-md-4">
                  <div className="fancy-tripple">
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>{s?.nat}</p>{" "}
                        <p className={`mb-0 ${exp > 0 ? "book-green" : "book-red"}`}>
                          {exp ? formatBook(exp) : 0}
                        </p>
                      </div>{" "}
                      <div
                        data-title={s?.gstatus}
                        className={cls}
                        onClick={() => !suspended && !noVal && onBetClick?.(s.b, s?.nat, s, "back")}
                      >
                        <span className="d-block odds">{noVal ? "—" : s.b}</span>{" "}
                        {Number(s?.bs) !== 0 && !noVal && s?.bs != null ? (
                          <span className="d-block">{formatSize(s.bs)}</span>
                        ) : null}
                      </div>{" "}
                      <div className="fancy-min-max">
                        Min:<span>{formatLimit(s?.min)}</span> Max:<span>{formatLimit(s?.max)}</span>
                      </div>
                    </div>{" "}
                    {s?.rem && s.rem !== "" ? <div className="market-message">{s.rem}</div> : null}
                  </div>
                </div>
              );
            })}
          </div>
        </Collapse>
      </div>
    </div>
  );
}
